import * as _LottieOptions from './LottieOptions';

export { default } from './Animation';
export * from './Animation';

export const LottieOptions = {
  ..._LottieOptions,
};
